export default "/images/smart_contracts_development/nft_attacks_1.png";